import type { GhrTask } from "@/types/task";

const OVERDUE_LIMIT_MS = 3 * 24 * 60 * 60 * 1000;

export const isTaskOverdue = (task: GhrTask): boolean =>
  Date.now() - new Date(task.created_at).getTime() > OVERDUE_LIMIT_MS;
